const ExtraItem = {
	img: '',
	url: '',
	text: '',
	price: '',
	quality: ''
};

/**
 * Kallebakom alternative option item
 * @param {ExtraItem} item
 * @param {number} index index in the list
 * @returns html String
 */
export const extraItem = (item, id, index) => {
	if (!item) {
		return;
	}

	return `
		<li>
			${item.url ? `<a href="${item.url}" class="link-item" data-value="${index + 1}" target="_blank" data-kalleid="${id}">` : `<span class="link-item" data-value="${index + 1}" target="_blank" data-kalleid="${id}">`}
				<img class="kallebakom__additional--image" src="${item.img}" loading="lazy" alt="extra item" />
				<span class="kallebakom__additional--model">${item.name}</span>
				${item.price ? `<span class="kallebakom__additional--price">${item.price}</span>` : ``}
				${item.quality ? `<span class="kallebakom__additional--quality">${item.quality}</span>` : ``}
			${item.url ? `</a>` : `</span>`}
		</li>
  	`;
};
